import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import IconCheckBig from "../../../assets/Images/Icons/IconCheckBig";
import RefreshIcon from "@mui/icons-material/Refresh";

const StepIndicator = ({ currentStep, stepConfig }) => {
    const theme = useContext(ThemeContext);

    const steps = [
        { key: 'templateInfo', label: 'Setup', number: 1 },
        { key: 'participants', label: 'Split', number: 2 },
        { key: 'initialStatement', label: 'Charge', number: 3 }
    ];

    const getStepStatus = (stepKey, index) => {
        if (!stepConfig[stepKey]) return 'hidden';
        if (stepConfig[stepKey] === 'disabled') return 'completed';
        if (stepConfig[stepKey] === 'enabled') return 'active';
        return 'pending';
    };

    const getStepIndex = (stepKey) => {
        return steps.findIndex(s => s.key === stepKey);
    };

    const currentStepIndex = getStepIndex(currentStep);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 3,
                pb: 2,
                borderBottom: `1px solid ${theme.colors.text}40`
            }}
        >
            {steps.map((step, index) => {
                const status = getStepStatus(step.key, index);
                const isActive = status === 'active';
                const isCompleted = status === 'completed';
                const isPending = index > currentStepIndex; // Steps we haven't reached yet

                // Determine opacity based on whether this is the current step
                const opacity = isActive ? 1 : 0.5;

                return (
                    <React.Fragment key={step.key}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                flex: 1,
                                position: 'relative',
                                opacity: opacity,
                                transition: 'opacity 0.3s ease'
                            }}
                        >
                            {/* Step Circle */}
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: isCompleted
                                        ? theme.colors.primary
                                        : isActive
                                            ? theme.colors.secondary
                                            : 'transparent',
                                    border: `2px solid ${
                                        isCompleted
                                            ? theme.colors.primary
                                            : isActive 
                                                ? theme.colors.secondary
                                                : theme.colors.text + '60'
                                    }`,
                                    color: isCompleted
                                        ? theme.colors.text
                                        : isActive || isPending
                                            ? theme.colors.primary
                                            : theme.colors.text + '60',
                                    fontWeight: 'bold',
                                    mb: 1,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                {isCompleted && (
                                    <IconCheckBig color={theme.colors.brandSuccess}/>
                                ) || (
                                <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color:isActive?theme.colors.primary:theme.colors.secondary}}>
                                    {step.number}
                                </Typography>
                                    )}
                            </Box>

                            {/* Step Label */}
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    color: isActive || isCompleted
                                        ? theme.colors.text
                                        : theme.colors.text + '60',
                                    fontWeight: isActive ? 'bold' : 'normal',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                {step.label}
                            </Typography>
                        </Box>

                        {/* Connector Line */}
                        {index < steps.length - 1 && (
                            <Box
                                sx={{
                                    flex: 1,
                                    height: '2px',
                                    backgroundColor: isCompleted
                                        ? theme.colors.primary
                                        : theme.colors.text + '30',
                                    mx: 1,
                                    mt: '-20px',
                                    transition: 'all 0.3s ease',
                                    opacity: opacity
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </Box>
    );
};

export default StepIndicator;
